import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {catchError, throwError} from "rxjs";
import {CoOpMemberService} from "../../../services-otc/co-op-member.service";

@Component({
    selector: 'app-add-co-op',
    templateUrl: './add-co-op.component.html',
    styleUrls: ['./add-co-op.component.css'],
    standalone: false
})
export class AddCoOpComponent {
  addCoOpForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      private addCoOpFormFb: FormBuilder,
      public dialogRef: MatDialogRef<OrderComponent>,
      private coOpMemberService: CoOpMemberService,
  ) {
    this.addCoOpForm = this.addCoOpFormFb.group({
      newCoOpnumber: new FormControl(''),
    });
  }
  cancelAddingCoOP(){
    this.dialogRef.close();
  }
  addCoOpMember() {
    if (this.data.soldToTenantId && this.data.payerTenantId){
      let coOpmemberNumberObj = {
        soldToTenantId: this.data.soldToTenantId,
        payerTenantId: this.data.payerTenantId,
        newCoOpnumber: this.addCoOpForm.get('newCoOpnumber').value,
      };
      // console.log(coOpmemberNumberObj, 'coOpmemberNumberObj addCoOpMember');
      this.coOpMemberService.postNewCoOpNumber(coOpmemberNumberObj.soldToTenantId, coOpmemberNumberObj.payerTenantId, coOpmemberNumberObj.newCoOpnumber).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }

}
